import type { AdminSidebarComponentProps } from '@website-editor/customComponents/CustomJsonComponent/JsonComponent.types';
import { CustomJSONBlobComponent, GuestSiteComponentProps } from './types';
import { ThingsToDoConfig } from '@website-editor/customComponents/CustomJsonComponent/components/ThingsToDo/ThingsToDo.config';
import { DefaultThingsToDoConfig } from '@website-editor/customComponents/CustomJsonComponent/components/DefaultThingsToDo/DefaultThingsToDo.config';
import { GeneralScheduleConfig } from '@website-editor/customComponents/CustomJsonComponent/components/GeneralSchedule/GeneralSchedule.config';
import { FormDisplayConfig } from '@website-editor/customComponents/CustomJsonComponent/components/FormDisplay/FormDisplay.config';
import { VipConfig } from '@website-editor/customComponents/CustomJsonComponent/components/Vip/Vip.config';
import { WeatherReportConfig } from '@website-editor/customComponents/CustomJsonComponent/components/WeatherReport/WeatherReport.config';
import { FaqConfig } from '@website-editor/customComponents/CustomJsonComponent/components/Faq/Faq.config';

// Add all your custom components here so they can be picked up and rendered.
export const CUSTOM_JSON_COMPONENT_TYPES: CustomJSONBlobComponent<AdminSidebarComponentProps, GuestSiteComponentProps>[] = [
  ThingsToDoConfig,
  DefaultThingsToDoConfig,
  GeneralScheduleConfig,
  FormDisplayConfig,
  VipConfig,
  WeatherReportConfig,
  FaqConfig,
];
export type CustomJsonComponentConfig = (typeof CUSTOM_JSON_COMPONENT_TYPES)[number];
